import { DettaglioListLottoDto, DettaglioListLottoDtoPagedListDto, LottoDto } from "@desio/api";
import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "store";
import { FormRicercaLotti, HomeCampagnaReducerType } from "./types";

const homeCampagnaReducer = (state: RootState) => state.homeCampagna;

export const dettaglioListLotti = createSelector(
  homeCampagnaReducer,
  (state: HomeCampagnaReducerType): DettaglioListLottoDto[] => {
    return state.pageCampagna?.items || [];
  }
);

export const pageCampagneSelector = createSelector(
  homeCampagnaReducer,
  (state: HomeCampagnaReducerType): DettaglioListLottoDtoPagedListDto | undefined => {
    return state.pageCampagna;
  }
)

export const lottoCaricatoSelector = createSelector(
  homeCampagnaReducer,
  (state: HomeCampagnaReducerType): LottoDto | undefined => {
    return state.lottoCaricato;
  }
)

export const dataInizio = createSelector(
  homeCampagnaReducer,
  (state: HomeCampagnaReducerType): Date => {
    return state.dataInizio;
  }
);

export const dataFine = createSelector(
  homeCampagnaReducer,
  (state: HomeCampagnaReducerType): Date => {
    return state.dataFine;
  }
);
export const paginaSelezionataSelector = createSelector(
  homeCampagnaReducer,
  (state: HomeCampagnaReducerType): number => {
    return state.paginaSelezionata;
  }
);
export const isFirstPageSelector = createSelector(
  homeCampagnaReducer,
  (state: HomeCampagnaReducerType): boolean => {
    return !!state.pageCampagna?.isFirstPage;
  }
);
export const isLastPageSelector = createSelector(
  homeCampagnaReducer,
  (state: HomeCampagnaReducerType): boolean => {
    return !!state.pageCampagna?.isLastPage;
  }
);
export const numeroTotalePagineSelector = createSelector(
  homeCampagnaReducer,
  (state: HomeCampagnaReducerType): number | undefined => {
    return state.pageCampagna?.pageCount;
  }
);

export const formRicercaLottiSelector = createSelector(
  homeCampagnaReducer,
  (state: HomeCampagnaReducerType): FormRicercaLotti => {
    return state.formRicerca;
  }
);